import React, { useState, useRef } from 'react';
import Lottie from 'lottie-react';
import lockAnimation from '../../../assests/images/Animations/Lock.json'; // Path to your Lottie animation
import TextField from '@mui/material/TextField'; // MUI TextField for the OTP input
import loginStyles from '../../../pages/Login/Login.module.scss';

const cx = (...names) => names.filter(Boolean).map((n) => loginStyles[n]).filter(Boolean).join(' ');

const VerifyOtpComponent = ({ t, isRTL, handleVerifyOtp, handleSendOtp,setOtp, errorMessage, setErrorMessage }) => {
  const [otpDigit, setOtpDigit] = useState(Array(6).fill(''));
  const [hasError, setHasError] = useState(false);
  const inputs = useRef([]);

  const handleChangeText = (text, index) => {
    if (text.length > 1) {
      return; // Prevent more than one character in the input
    }

    const newOtpDigit = [...otpDigit];
    newOtpDigit[index] = text;
    setOtpDigit(newOtpDigit);
    setOtp(newOtpDigit.join(''));
    setHasError(false); // Reset error state when the user changes the text
    if (setErrorMessage) {
      setErrorMessage('');
    }

    // Automatically focus on the next input if a digit is entered
    if (text && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyPress = (event, index) => {
    if (event.key === 'Backspace') {
      if (otpDigit[index]) {
        // If the current input has a value, clear it
        const newOtpDigit = [...otpDigit];
        newOtpDigit[index] = '';
        setOtpDigit(newOtpDigit);
        setOtp(newOtpDigit.join(''));
      } else if (index > 0) {
        // If the current input is empty, move to the previous input
        inputs.current[index - 1].focus();
      }
    }
  };



  return (
    <div className={cx('verify-otp-container')}>
      <div className={cx('animations-container')}>
        <Lottie
          animationData={lockAnimation}
          loop
          style={{ width: '100%', height: 'auto' }}
        />
      </div>

      <div className={cx('otp-details-container')}>
        <p className={cx('receive-6-digit-code')}>

          {isRTL ? (
            <>
              <span className={cx('code-text')}> {t('ReceivedA')}{' '} {t('Code')}</span>{' '}
              <span className={cx('highlight-text')}>{t('SixDigit')}</span>
            </>
          ) : (
            <>
              <span className={cx('highlight-text')}>{t('SixDigit')}</span>{' '}
              <span className={cx('code-text')}>{t('Code')}</span>
            </>
          )}
        </p>
        <p className={cx('password-details')}>{t('EnterCodeToResetPassword')}</p>
      </div>

      <div className={cx('otp-inputs-container')}>
        {otpDigit.map((digit, index) => (
          <TextField
            key={index}
            inputRef={(el) => (inputs.current[index] = el)}
            variant="standard"
            value={digit}
            onChange={(e) => handleChangeText(e.target.value, index)}
            InputProps={{
              disableUnderline: true,
              inputProps: {
                maxLength: 1,
                inputMode: 'numeric',
                style: {
                  textAlign: 'center',
                  padding: 0,
                },
              },
            }}
            onKeyDown={(e) => handleKeyPress(e, index)}
            sx={{
              borderRadius: '8px',
              backgroundColor: digit ? 'rgba(249, 170, 42, 1)' : 'rgba(254, 247, 234, 1)',
              transition: 'background-color 0.2s ease, transform 0.15s ease',
              '& .MuiInputBase-root': {
                height: '100%',
              },
              '& .MuiInputBase-input': {
                textAlign: 'center',
                color: digit ? '#fff' : 'inherit',
                fontWeight: 600,
              },
            }}
            error={hasError || Boolean(errorMessage)}
          />
        ))}
      </div>
      {errorMessage ? <div className={cx('error-message')}>{errorMessage}</div> : null}
      <button className={cx('login-button')} onClick={handleVerifyOtp}>{t('verify code')}</button>
      <div className={cx('resend-otp-container')}>
        {isRTL ? (
          <>
            <p>{t('DidNotReceiveCode')}</p>
            <button className={cx('DidNotReceiveCode-button')} onClick={handleSendOtp}>{t('SendAgainIn5Seconds')}</button>
          </>
        ) : (
          <>
            <p>{t('DidNotReceiveCode')}</p>
            <button className={cx('DidNotReceiveCode-button')} onClick={handleSendOtp}>{t('SendAgainIn5Seconds')}</button>
          </>
        )}
      </div>


    </div>
  );
};

export default VerifyOtpComponent;
